import { render, staticRenderFns } from "./UpgradePromo.vue?vue&type=template&id=4f954a9f&"
import script from "./UpgradePromo.vue?vue&type=script&lang=js&"
export * from "./UpgradePromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f954a9f')) {
      api.createRecord('4f954a9f', component.options)
    } else {
      api.reload('4f954a9f', component.options)
    }
    module.hot.accept("./UpgradePromo.vue?vue&type=template&id=4f954a9f&", function () {
      api.rerender('4f954a9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/2.0/js/core/Components/UpgradePromo.vue"
export default component.exports